import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

export default abstract class GeometryService {
  private static geometryEndpoint = `${routes.apiRoutes.basePath}/api/geometry/v2/geometry`;

  static async createGeometry(geometryName: string, startTs: number, masterId: number, geoZip: File): Promise<any> {
    const formData = new FormData();
    formData.append('masterId', masterId.toString());
    formData.append('geoZip', geoZip);
    return fetch(this.geometryEndpoint, {
      method: 'POST',
      headers: {
        Authorization: userManager.getApiKey()
      },
      body: formData
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then(text => ({ notificationStatus: 'error', code: response.status, message: text }));
        }
        return response.json();
      });
  }
}
